import api from './api';

// Talks to /api/purchase/* — stocked (procurement) landed-cost pricing.
export const purchaseService = {
  getWarehouses: async (siteCode) => {
    const res = await api.get('/purchase/warehouses', { params: { site: siteCode } });
    return res.data;
  },

  getProductClasses: async () => {
    const res = await api.get('/purchase/product-classes');
    return res.data;
  },

  // Currencies + base conversion rates for the pricing grid.
  getCurrencies: async () => {
    const res = await api.get('/purchase/currencies');
    return res.data;
  },

  // Active suppliers, for the Supplier column on the pricing grid.
  getSuppliers: async () => {
    const res = await api.get('/purchase/suppliers');
    return res.data;
  },

  // params: { warehouse, year, period, productClass? }
  getStocked: async (params) => {
    const res = await api.get('/purchase/stocked', { params });
    return res.data;
  },

  // payload: { warehouse_id, financial_year, financial_period(s),
  //            changes:   [ { stock_code, component_code, amount, currency } ],
  //            suppliers: [ { stock_code, supplier_code } ] }
  // The supplier list is separate because a supplier belongs to the ITEM, not
  // to one component of its landed-cost build-up.
  saveStocked: async (payload) => {
    const res = await api.put('/purchase/stocked', payload);
    return res.data;
  },

  // Monthly landed pricing: the whole year in one read.
  // params: { warehouse, year, productClass? }
  getStockedMonthly: async (params) => {
    const res = await api.get('/purchase/stocked/monthly', { params });
    return res.data;
  },

  // payload: { warehouse_id, financial_year,
  //            changes: [ { stock_code, financial_period, component_code, amount, currency } ] }
  // One value PER PERIOD (the monthly page solves a base price per month).
  saveStockedMonthly: async (payload) => {
    const res = await api.put('/purchase/stocked/monthly', payload);
    return res.data;
  },

  // Non-stocked (opex) pricing -> bud_opex_items. Version + site come from the
  // request context headers. Returns items with a per-period cost map.
  getNonStocked: async () => {
    const res = await api.get('/purchase/non-stocked');
    return res.data;
  },

  // payload: { changes: [ { item_label, financial_period, cost_amount } ] }
  saveNonStocked: async (payload) => {
    const res = await api.put('/purchase/non-stocked', payload);
    return res.data;
  },

  // Distinct non-stocked item labels for the active version+site (search picker).
  getNonStockedItems: async () => {
    const res = await api.get('/purchase/non-stocked/items');
    return res.data;
  },

  // Register a non-stocked item (seeds bud_opex_items). Optional UoM is stored
  // on the seeded rows.
  // glLineId lets the API file the item against the GL line's OWN site rather
  // than the header site (they differ in "All sites" mode).
  registerNonStockedItem: async (itemLabel, unitOfMeasure, glLineId = null) => {
    const res = await api.post('/purchase/non-stocked/item', {
      item_label: itemLabel,
      unit_of_measure: unitOfMeasure || null,
      gl_line_id: glLineId,
    });
    return res.data;
  },
};

export default purchaseService;
